// import { TextField, Label, Input, TextFieldCo } from '@/components/ui/TextField'
// import ReactDatePicker from '@/components/ui/ReactDatePicker'
import { TextField } from '@/components/ui/TextField'
import { Button } from '@/components/ui/button'
import { SearchIcon } from 'lucide-react'
// import { Label } from '@/components/ui/Label'
// import { Button } from '@/components/ui/button'

export default function InputFieldsDemo() {
  // const [date, setDate] = useState(null)
  return (
    <div className="">
      {/* <ReactDatePicker onChange={(e) => setDate(e)} selected={date} /> */}
      <input type="text" disabled value="ssssssssssrrr" />
      Disaabled
      <TextField.Input
        disabled
        placeholder="Placeholder"
        leadingIcon={<SearchIcon className="" />}
        trailingIcon={<div className="size-auto">action button</div>}
      />
      <hr className="my-4" />
      <TextField.Input
        placeholder="Placeholder"
        leadingIcon={<SearchIcon className="" />}
        trailingIcon={<div className="size-auto">action button</div>}
      />
      <hr className="my-4" />
      Large
      <TextField.Input
        large
        placeholder="Placeholder"
        leadingIcon={<SearchIcon className="" />}
        trailingIcon={<SearchIcon className="" />}
      />
      <hr className="my-4" />
      <TextField status="error" statusText="EEEEErrrr">
        <TextField.Label className="flex justify-between">
          <span>first</span>
          <span>second</span>
        </TextField.Label>

        <TextField.Input />
      </TextField>
      <hr className="my-4" />
      <TextField status="success" statusText="Success">
        <TextField.Label className="">This is a another</TextField.Label>

        <TextField.Input
          placeholder="Placeholder"
          leadingIcon={<SearchIcon className="" />}
          trailingIcon={
            <div className="size-auto">
              <Button iconOnly size="sm">
                <SearchIcon />
              </Button>
            </div>
          }
        />
        <TextField.Description className="">
          <span>This is a caption</span>
        </TextField.Description>
      </TextField>
      <hr className="my-4" />
      <TextField status="success" statusText="Success" disabled>
        <TextField.Label className="">Disabled field</TextField.Label>

        <TextField.Input
          placeholder="Placeholder"
          leadingIcon={<SearchIcon className="" />}
          trailingIcon={
            <div className="size-auto">
              <Button iconOnly size="sm">
                <SearchIcon />
              </Button>
            </div>
          }
        />
        <TextField.Description className="">
          <span>This is a caption</span>
        </TextField.Description>
      </TextField>
    </div>
  )
}
